import { registerComponent } from '@gig/magic-common';
import ButtonComponent from './button.vue.js';
export { default as ButtonComponent } from './button.vue.js';

var Button = registerComponent(ButtonComponent);

export { Button };
